import styled from "@emotion/styled";
import { css } from '@emotion/core'
import {themeColor, themeDefault} from '../layout/global-style';

const isActive = (props) => !props.active ? css`` :
    css`
    color: #FD0130;
    svg {
        fill:#FD0130;    
        stroke:#FD0130;
    }     
`

const isInvertColors = (props) => !props.invert ? css`` :
    css`
    color: ${themeColor.black};
    svg {
        fill:${themeColor.black};    
        stroke:${themeColor.black};
    }
    /*& :hover{
        color: #FD0130;
        svg {
            fill:#FD0130;    
            stroke:#FD0130;
        }
    } 
    */    
`

export const ImageButton = styled.button`
    //cursor: pointer;
    position: relative;
    display: flex;
    margin: 0;
    padding: 0 ;
    outline: none;
    background: none;  
    border: none;
    align-items: center;
    justify-content: center;
    color: #02d7f2;    
    pointer-events: all;
    svg {
        fill:#02d7f2;    
        stroke:#02d7f2;
    }
    & :hover{
        color: #FAEF19;    
        svg {
            fill: #FAEF19;
            stroke: #FAEF19;
        }
    }
    & :disabled {
        color: #ccc;    
        svg {
            fill: #ccc; 
            stroke: #ccc;  
        }
    } 
    
    span {
        position: absolute;
    } 
    
    ${isActive}     
    ${isInvertColors}    
`;
export const Label = styled.span`
    display: flex;    
    padding: 0;
    font-family: ff-good-web-pro-condensed, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 26px;
    text-align: center;
    text-transform: uppercase; 
    align-items: center;
    white-space: nowrap;   
`;
